import { Client } from '@urbasolar_dev/urbaconnect-types'

import { useFetchApi } from '../../adapter/fetchApi'

/**
Hook used for authentication functions
 * @returns Object avec les fonctions API d'authentification
 */
export const useAuthenticationApi = () => {
  const fetchApi = useFetchApi()

  return {
    getCurrentUser: async (): Promise<Client | undefined> => {
      return (await fetchApi<Client>('users/current')) as Client | undefined
    },
  }
}
